import { Buffer } from 'buffer';


export const encrypt = (input, HIBA_SALT) => {
  console.log('* encrypting hiba...');
  const key = HIBA_SALT;
  let result = '';

  for (let i = 0; i < input.length; i++) {
    let char = input.substr(i, 1);
    let keychar = key.substr((i % key.length) - 1, 1);
    char = String.fromCharCode(char.charCodeAt(0) + keychar.charCodeAt(0));
    result += char;
  }

  return Buffer(result, 'binary').toString('base64');
};


if (process.env.NODE_ENV === 'development') window.hibaEncrypt = encrypt;